// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"bN-z","carouselContainer":"cN-z"};